import api from '../_api'
import {
    FETCH_REGULAR_BILLING_HISTORY_REQUEST,
    FETCH_REGULAR_BILLING_HISTORY_SUCCESS,
    FETCH_REGULAR_BILLING_HISTORY_FAILED,
    FETCH_REGULAR_BILLING_INFO_REQUEST,
    FETCH_REGULAR_BILLING_INFO_SUCCESS,
    FETCH_REGULAR_BILLING_INFO_FAILED
} from './mutation-type'

const getRegularBillingHistory = async ({ commit, state, getters, rootGetters }, { projectIdx, usageAccountId }) => {
    commit(FETCH_REGULAR_BILLING_HISTORY_REQUEST)
    try {
        const { status, data } = await api.fetchRegularBillingHistory({ projectIdx, usageAccountId }, rootGetters.requiredService)
        commit(FETCH_REGULAR_BILLING_HISTORY_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_REGULAR_BILLING_HISTORY_FAILED, error)
        throw error
    }
}

const getRegularBillingAllatkey = async ({ commit, state, getters, rootGetters }, { usageAccountId }) => {
    commit(FETCH_REGULAR_BILLING_INFO_REQUEST)
    try {
        const { status, data } = await api.fetchRegularBillingInfo({ usageAccountId }, rootGetters.requiredService)
        commit(FETCH_REGULAR_BILLING_INFO_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_REGULAR_BILLING_INFO_FAILED, error)
        throw error
    }
}

export default {
    getRegularBillingHistory,
    getRegularBillingAllatkey
}
